module.exports = __webpack_public_path__ + "img/legume-fava-beans-190x100.a5b99ff2.jpg";